import SEO from "../components/SEO";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import OrgPasswordLogin from "../components/OrgPasswordLogin";
import FooterHome from "../components/FooterHome";
import ResetPassword from "../components/ResetPassword";
import { StickyOrgNavbar } from "../OrgNavbar";
import { IconButton, Typography } from "@material-tailwind/react";
import { LockClosedIcon } from "@heroicons/react/24/outline";

export default function OrgPasswordLoginPage() {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const location = useLocation();
  const isSignupJourney = new URLSearchParams(location.search).get("tab") === "signup";
  const passwordSetupComplete = new URLSearchParams(location.search).get("setup") === "complete";

  return (
    <>
      <SEO title={isSignupJourney ? "Start with a free strategy sandbox" : "Sign In"} noIndex />
      <div className="flex min-h-screen flex-col">
        <StickyOrgNavbar />
        <main className={isSignupJourney
          ? "grid flex-1 content-center gap-8 bg-slate-50 px-4 py-8 sm:px-6 sm:py-12 lg:grid-cols-2 lg:gap-12"
          : "flex flex-1 flex-col items-center justify-center bg-slate-50 px-4 py-8 sm:px-6 sm:py-12"}
        >
          <div className={`flex w-full max-w-lg flex-col items-center rounded-2xl bg-iconBlue px-5 py-7 shadow-xl shadow-blue-950/20 sm:px-8 sm:py-9 ${isSignupJourney ? "justify-self-center lg:justify-self-end" : ""}`}>
          <header className="w-full text-center">
            <img
              src="/logo512.png"
              alt="StunM"
              className="mx-auto h-12 w-auto sm:h-14"
            />
            <h1 className="mt-4 text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Welcome to StunM
            </h1>
            <p className="mt-2 text-sm leading-6 text-white/80 sm:text-base">
              {passwordSetupComplete ? "Your password is set. Sign in with the email and password you chose." : "Sign in to manage your organization’s marketing workflow."}
            </p>
          </header>

          <div className="mt-5 flex flex-col items-center">
            
            {/* Reset Password Icon Button */}
            <IconButton
              variant="outlined"
              className="group relative mx-auto flex justify-center rounded-md border border-white/40 bg-transparent px-4 py-2 text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-iconBlue"
              onClick={() => setShowResetPassword(!showResetPassword)}
              aria-label={showResetPassword ? "Hide password reset form" : "Reset your password"}
              aria-expanded={showResetPassword}
            >
              <LockClosedIcon className="h-6 w-6" />
            </IconButton>
            <Typography
              variant="small"
              className="mt-2 text-center text-white/90"
            >
              Reset password
            </Typography>
          </div>

          {/* Conditionally Render Reset Password Component */}
          {showResetPassword && (
            <ResetPassword onClose={() => setShowResetPassword(false)} defaultAccountType={passwordSetupComplete ? "user" : "owner"} />
          )}

          <div className="mt-5 flex w-full justify-center">
            <OrgPasswordLogin />
          </div>
          </div>
          {isSignupJourney && (
            <section className="w-full max-w-xl justify-self-center overflow-hidden rounded-2xl bg-slate-950 p-2 shadow-xl sm:p-4 lg:justify-self-start lg:self-center" aria-label="GTM Blueprint product demo">
              <video
                className="pointer-events-none aspect-[1.686/1] w-full select-none rounded-xl"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                onLoadedMetadata={(event) => {
                  event.currentTarget.playbackRate = 2.5;
                }}
                disablePictureInPicture
                controlsList="nodownload nofullscreen noremoteplayback"
                tabIndex={-1}
                onContextMenu={(event) => event.preventDefault()}
              >
                <source src="/demo_blueprint.mp4" type="video/mp4" />
              </video>
            </section>
          )}
        </main>
        <FooterHome />
      </div>
    </>
  );
}
